import i18n from 'config/i18n';
import { path } from 'ramda';

import { formatByLocale, getLocale } from 'utils/date';

interface Params<T> {
  codeField: string;
  nameField: string;
  fromField: string;
  toField: string;
  item: T;
}

const t = i18n.getFixedT(getLocale(), 'common');

export const getFormattedCostCenters = <T>({
  codeField,
  nameField,
  fromField,
  toField,
  item
}: Params<T>) => {
  return `${item[codeField]} - ${item[nameField]} - ${t(
    'from'
  )} ${formatByLocale(new Date(path(fromField.split('.'), item) ?? ''))} ${t(
    'to'
  )} ${formatByLocale(new Date(path(toField.split('.'), item) ?? ''))}`;
};
